import React, {useCallback, useState} from 'react'
import {Modal} from './modal'
import {FiX} from "react-icons/fi";
import {Trans, useTranslation} from "react-i18next";
import {Loader} from "../loader";
import {Checkbox} from "../form/field/checkbox";
import {Alert} from "../alert";
import { IconTrash } from '../icons';
import styled from 'styled-components'
import {ButtonPrimary, ButtonSecondary} from "../button";


const IconPlace = styled.span`
	display: flex;
	width: 40px;
	height: 40px;
	justify-content: center;
	align-items: center;
	/* gap: 8px; */
	aspect-ratio: 1/1;
	flex-grow: 0;
	flex-shrink: 0;

	border-radius: 999px;
	background: rgba(228, 40, 27, 0.15);
	color: red;
`
const ModalHeader = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;
`
const ModalHLine = styled.div`
	width: 416px;
	height: 1px;
	background: rgba(255, 255, 255, 0.06);
`
const ModalFooter = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 12px;
	align-self: stretch;
`
const ModalItem = styled.div`
	&[data-text] {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: flex-start;
		gap: 8px;
	}
`
const ModalTitle = styled.div`
	color: #FFF;
	font-family: 'Druk Wide';
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 120%; /* 16.8px */
	letter-spacing: 0.42px;
	text-transform: uppercase;
`
const ModalBody = styled.div`
	color: rgba(255, 255, 255, 0.60);
	font-family: 'Basis Grotesque Pro';
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 120%; /* 16.8px */
	letter-spacing: 0.42px;
`
const ButtonCancel = styled(ButtonSecondary)`
	flex: 1 0 0;
`

const ButtonConfirm = styled(ButtonPrimary)`
	flex: 1 0 0;
	/*color: var(--it-text-white);
		
	&:hover {
		color: var(--it-bg-dark-1);
	}*/
`

export const ModalConfirm = ({
								 title, icon,
								 buttonTitle, buttonClassName,
								 body,
								 onCancel, onConfirm,
								 isLoading = false,
								 ...rest
							 }) => {
	const {t} = useTranslation();

	return (
		<Modal {...rest} onClose={onCancel}>
			{/* <div className="relative p-4 flex-auto">
				<div className="flex items-start justify-start p-2 space-x-4">
					<div className="flex-shrink-0 w-12">{icon}</div>
					<div className="flex flex-col w-full">
						<div className="text-lg mb-2 font-bold">{title}</div>
						{body}
					</div>
				</div>
			</div>
			<div
				className="flex items-center justify-end p-4 border-t border-grey-200 dark:border-grey-700 border-solid rounded-b space-x-2">

				{isLoading ? <Loader show={true} className={"mb-4"} /> : <>
					<button
						className="btn btn-default btn-rounded bg-white hover:bg-grey-100 text-grey-900"
						type="button"
						onClick={onCancel}>
						Cancel
					</button>
					<button
						className={buttonClassName}
						type="button"
						onClick={onConfirm}>
						{buttonTitle}
					</button>
				</>}
			</div> */}
			<ModalHeader>
				<ModalItem>{ icon }</ModalItem>
				<ModalItem data-text>
					<ModalTitle>{ title }</ModalTitle>
					<ModalBody>{ body }</ModalBody>
				</ModalItem>
			</ModalHeader>
			<ModalHLine />
			<ModalFooter>
				{
					isLoading
						? <Loader show={true} className={"mb-4"} />
						: <>
							{/* <button className="btn btn-default btn-rounded bg-white hover:bg-grey-100 text-grey-900" type="button" onClick={onCancel} >Cancel</button> */}
							{/* <button className={buttonClassName} type="button" onClick={onConfirm} >{buttonTitle}</button> */}
							<ButtonCancel type="button" onClick={onCancel}>{ t(`modal.btn.cancel`) }</ButtonCancel>
							<ButtonConfirm type="button" onClick={onConfirm} data-red>{ buttonTitle }</ButtonConfirm>
						</>
				}
			</ModalFooter>
		</Modal>
	)
}


export const ModalConfirmDelete = ({title, description, itemIds, body, ...rest}) => {
	const {t} = useTranslation();

	return <>
		<ModalConfirm
			icon={
				<IconPlace>
					<IconTrash size={20} />
				</IconPlace>
				// <span className="h-10 w-10 bg-red-100 text-white flex items-center justify-center rounded-full text-lg font-display font-bold">
				//     <FiX size={18} className="stroke-current text-red-500"/>
				// </span>
			}
			title={title || t('modal.confirmdelete.title')}
			body={
				body || <div className="text-sm text-grey-500">
					{
						description || <Trans
							i18nKey={Array.isArray(itemIds) ?
								"modal.confirmdelete.description_multi"
								: "modal.confirmdelete.description"}
							components={{ b: <strong className={`text-red-600`} /> }}
							values={{count: Array.isArray(itemIds) ? itemIds.length : 0}}
						/>
					}
				</div>
			}
			buttonTitle={t('modal.confirmdelete.button_confirm')}
			buttonClassName="btn btn-default btn-rounded bg-red-500 hover:bg-red-600 text-white"
			{...rest}
		/>
	</>
}

export const ModalConfirmDeleteDomains = ({onConfirm, itemIds, ...props}) => {
	const {t} = useTranslation();
	const [withApps, setWithApps] = useState(false)

	const _onConfirm = useCallback((e)=>{
		onConfirm && onConfirm(e, {withapps: withApps})
	}, [withApps, onConfirm])
	return (
		<ModalConfirmDelete {...props} itemIds={itemIds}
							body={
							<>
								<div className="text-sm text-grey-500">
									<Trans
										i18nKey={Array.isArray(itemIds) ?
											"modal.confirmdelete.description_multi"
											: "modal.confirmdelete.description"}
										components={{ b: <strong className={`text-red-600`} /> }}
										values={{count: Array.isArray(itemIds) ? itemIds.length : 0}}
									/>
								</div>
								<div className={`mt-4`}>
									<Checkbox label={t(`modal.confirmdeletedomains.remove_with_apps`)}
											  name={`removeApps`}
											  onChange={(e, isChecked) => setWithApps(isChecked)}  />
									{withApps && <Alert
										color="bg-transparent border-red-500 text-red-500"
										borderLeft
										raised>
										{t(`modal.confirmdeletedomains.all_apps_willbe_deleted`, )}
									</Alert>}
								</div>
							</>
							}
							onConfirm={_onConfirm} />
	)
}


